import { produce } from 'immer';
import store, { State } from 'store';

export default function setRunName(runName: string) {
  store.setState(
    produce((state: State) => {
      state.startWorkflow.submit.runName = runName;
    }),
  );
}
